import { all } from 'redux-saga/effects';
import { watchList } from './list';

export function* watchInsuranceCompanies() {
  yield all([watchList()]);
}
